import React, { useState } from 'react';
import '../css/switchContentButton.css';
import { useMediaQuery } from '../../../../../context-module/context-configuration/auth-provider/mediaProvider/mediaProvider';

type Key = string | number;

interface SwitchContentItem {
  id: Key;
  title: string;
  description?: string;
}

interface SwitchContentButtonProps {
  items: SwitchContentItem[];
  defaultActiveId?: Key;
  onChange?: (activeId: Key | null) => void;
  className?: string;
}

const SwitchContentButton: React.FC<SwitchContentButtonProps> = ({
  items,
  defaultActiveId,
  onChange,
  className
}) => {
  const isMobile = useMediaQuery('(max-width: 850px)');
  const [activeId, setActiveId] = useState<Key | null>(
    defaultActiveId ?? null
  );

  const handleItemClick = (id: Key) => {
    setActiveId((prev) => {
      let newActiveId: Key | null;

      if (isMobile) {
        newActiveId = id;
      } else {
        newActiveId = prev === id ? null : id;
      }

      onChange?.(newActiveId);
      return newActiveId;
    });
  };


  return (
    <div
      className={`scl--web-component-switch-content-container ${className || ''}`}
    >
      {items.map((item) => {
        const isActive = activeId === item.id;
        
        return (
          <div //NOSONAR
            key={item.id}
            className={`scl--web-component-switch-content-item ${isActive ? 'active' : ''}`}
            onClick={() => handleItemClick(item.id)}
          >
            <div className="scl--web-component-switch-content-separator">
              <div className="scl--web-component-switch-content-line" />
            </div>

            <div className="scl--web-component-switch-content-row">
              <div className="scl--web-component-switch-content-title-wrapper">
                <span className="scl--web-component-switch-content-title">
                  {item.title}
                </span>
              </div>

              <div className="scl--web-component-switch-content-icon-wrapper">
                <svg
                  className={`scl--web-component-switch-content-arrow ${isActive ? 'rotated' : ''}`}
                  width="30"
                  height="27"
                  viewBox="0 0 30 27"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4 13.5H26M26 13.5L16.5 4M26 13.5L16.5 23"
                    stroke="#000000"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            </div>

            <div
              className={`scl--web-component-switch-content-description-wrapper ${isActive && item.description ? 'expanded' : ''}`}
            >
              {item.description && (
                <p className="scl--web-component-switch-content-description">
                  {item.description}
                </p>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SwitchContentButton;
